module.exports = __webpack_public_path__ + "img/khandevane-rgb.388aeaf.png";